<template>
  <div class="notice">
    <header-bar :name='"短视频拍摄技巧"'></header-bar>
    <!-- <div>
      <span class="back" @click="routerTo('/mpage/m_skill/m_skilllist')">
          <img src="../img/arrow.png" alt=""> 摄影技巧
        </span>
    </div> -->
    <div class="content">
      <div class="title">短视频拍摄技巧</div>
      <div class="word">
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >短视频拍摄技巧</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >短视频拍摄中的所有技法，都是在最基础的拍摄手法上，综合运用各种技法来打造出优质短视频内容。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >因此，拍摄短视频，首先就要掌握基础技法！</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >1.拍摄前设备准备</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >在开始拍摄前，我们需要先完成一个必要的步骤：准备拍摄设备。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >现在的手机功能很强大，拍摄功能齐全，基本上能满足一个简单的短视频拍摄要求。但如果条件允许，当然可以准备更好的拍摄设备。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >总体来说，拍摄短视频，最常用的设备有三种：手机、相机和摄像机。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >【拍摄设备及优缺点】</span
          >
        </p>
        <p style="text-align: center;">
          <img
            src="../img/skill/20210906-1630898316730599.jpg"
            title="20210906-1630898316730599.jpg"
            alt="wps1.jpg"
          />
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑">除了拍摄设备之外，</span>
            <span style="font-family: 微软雅黑"
              >我们还需要一些辅助工具，在拍摄过程中提升画面稳定性和画质清晰度。</span
            ></span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >辅助设备可以准备这些：手持云台、自拍杆、手机自动旋转器、补光灯、镜头、支架等。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑"
              >支架、手持云台可以避免因为手抖动造成的视频画面晃动等问题；借助手机自动旋转器，可以用手机进行</span
            ><span style="font-family: 微软雅黑"
              >360°的全景拍摄；补光灯可以改变光线，让脸部的肌肤呈现得更加自然。</span
            ></span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >2</span
            ></strong
          ><strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >.景别、运镜、构图技巧</span
            ></strong
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >1、景别</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >摄像机与拍摄主体距离不同，在相机中所呈现的大小也不同，不同距离所产生的的画面效果我们称之为景别。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px">主要分为：</span>
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >特写（人体肩部以上）</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >近景（人体胸部以上）</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >中景（人体膝部以上）</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >全景（人体的全部和周围背景）</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >远景（被拍摄主体所处的环境）</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >不同景别的画面，会产生不同的感受。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >我们以特写和全景为例：</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >特写：指人体肩部以上部分，或其他被摄对象的局部。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >拍摄视频时用特写镜头，一般是用来展现人物面部细微的表情，描绘人物的内心活动。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >例如，拍一个人看书的中景，给桌上的水一个特写，水就会与人物形成特定的关系。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >特写镜头能给人强烈的视觉感受，所以在拍摄时，不要随便使用，要恰到好处，才能起到画龙点睛的作用。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >全景：全景所展现的范围较大，全景拍摄时，画面中包含人、物、景的全貌。在拍摄时一般是作为摄像的总角度。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >全景的作用则是全面阐述人物与环境之间的联系，还能通过特定环境表现特定人物，比近景更能表达画面中人、物、景的联系。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >在叙事、抒情和阐述人物与环境的关系的功能上，起到了独特的作用。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >2、运镜</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >简单来说，运镜就是镜头运动、移动。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >在短视频拍摄过程中，我们要移动镜头来拍摄出不同的画面效果。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >在拍摄时，我们会根据不同的画面呈现要求，改变镜头的光轴或焦距，而通过这些不同的镜头运动变化，所产生的画面，就是运动画面。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >例如，通过推、拉、摇、移、跟、升降摄像和综合运动摄像形成的推镜头、拉镜头、摇镜头、移镜头、跟镜头、升降镜头和综合运动镜头等。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >通过不同的运镜手法拍摄不同的画面，是短视频拍摄指南中必备的技能。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >短视频拍摄中，拉镜头和移镜头较为常见，我们就以这两个运镜方式来说一说运镜的作用。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >拉镜头：摄像机渐渐远离拍摄主体，或变动镜头焦距，将画面框架从近到远拉开，与主体产生距离。</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898345510927.jpg"
            title="20210906-1630898345510927.jpg"
            alt="wps2.jpg"
          /><span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898372667167.jpg"
            title="20210906-1630898372667167.jpg"
            alt="wps3.jpg"
          /><img
            src="../img/skill/20210906-1630898385879241.jpg"
            title="20210906-1630898385879241.jpg"
            alt="wps4.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >短视频拍摄过程中使用拉镜头，由近到远，通过不断放大主体身边的环境，更有利于展现主体和环境的关系。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >例如，人在城墙下，镜头由近到远拉开，人物在环境的行为也渐渐展开，我们就能看看清楚她只是立在老城墙边拍照，还是在怀念环境带来的感触。</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898400625526.jpg"
            title="20210906-1630898400625526.jpg"
            alt="wps5.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >另外，拉镜头是在空间和方位上有所变化，这种画面对比能起到对比、反衬的效果。还有利于调动观众对即将出现的整体形象的想象和猜测。</span
          >
        </p>
        <p >
          <span style="font-family: 微软雅黑; font-size: 14px"
            >移镜头：移镜头的一个独特特点是，画面框架始终处于运动之中，画面的主体一直在不断移动。</span
          >
          
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898414144066.jpg"
            title="20210906-1630898414144066.jpg"
            alt="wps6.jpg"
          />
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >这种运镜手法有助于调动观众的视觉感受。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >例如，人群在大街上使用各种交通工具，或行走，或骑车等等，移动镜头则让人代入生活中的这种场景，更有身临其境的感觉。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >再者，移动镜头能在表现大场面、大纵深、多景物、多层次的复杂场景时具有气势恢宏的造型效果。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >例如我们在影视剧中看到的奔跑、城墙跳跃，军队出击等镜头。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >需要注意的是，我们在短视频拍摄过程中，尽量用变焦镜头中视角最广的那一端镜头。视角越广，它的特点体现的越明显，画面也容易保持稳定。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑"
              >例如，我们用手机拍摄，手机镜头的焦距一般在</span
            ><span style="font-family: 微软雅黑"
              >28-32mm之间，接近于”人眼所见“的取景范围，拍出来的效果就比较平淡。</span
            ></span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898427903750.jpg"
            title="20210906-1630898427903750.jpg"
            alt="wps7.jpg"
          /><span style="font-family: 微软雅黑; font-size: 14px">&nbsp;</span>
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >这个时候我们就可以手机的超广角功能，将画面都收进画面里，简单的景色立刻能变得气势磅礴。</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898441588146.jpg"
            title="20210906-1630898441588146.jpg"
            alt="wps7.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >以上只是我们对景别、运镜手法中的部分内容进行了阐述，而一个合格的短视频摄影师，需要掌握更全面的景别、运镜手法。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >3、构图</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >构图是根据画面的布局和结构，运用相机镜头的成像特征和摄影手法，在主题明确、主次分明、布局适宜的情况下，组成一幅简洁、多样、统一的画面。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >好的构图能让视频画面更富有表现力和艺术感染力。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑">豆瓣评分</span
            ><span style="font-family: 微软雅黑"
              >9.0的国产剧《琅琊榜》除了剧情让人称赞之外，构图也是让人啧啧称奇的一部分。</span
            ></span
          >
        </p>
        <p style="text-align: center">
          <span style="font-family: 微软雅黑; font-size: 14px">对角线构图</span>
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898460150560.jpg"
            title="20210906-1630898460150560.jpg"
            alt="wps9.jpg"
          />
        <p style="text-align: center">
          <span style="font-family: 微软雅黑; font-size: 14px"
            >V shape构图</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898474121074.jpg"
            title="20210906-1630898474121074.jpg"
            alt="wps10.jpg"
          />
        <p style="text-align: center">
          <span style="font-family: 微软雅黑; font-size: 14px">三分法构图</span>
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898489944418.jpg"
            title="20210906-1630898489944418.jpg"
            alt="wps11.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >三分法构图是短视频拍摄中较常用的构图方法。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >拍摄时，将画面的横向和纵向平均分成三份，线条交叉处叫做趣味中心，拍摄时尽量把主体安排在趣味中心附近，因为趣味中心是优先吸引用户目光的位置。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >除此之外，还有更简单，更适合新手练习的构图方法：</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >创造极简背景构图：很多时候，你想要的越多，最后出来的效果可能越差。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >新手在拍摄初期，构图时，尽量将背景简单化，重点突出主体，展现出来的效果会更高级。</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898505838539.jpg"
            title="20210906-1630898505838539.jpg"
            alt="wps12.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑">近距离构图：摄影大师</span
            ><span style="font-family: 微软雅黑"
              >Robert
              Capa曾经说过，“如果你拍的照片不够好，那是因为距离不够近。”</span
            ></span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >有些景物一定要使用微距镜头，才能展现它的美，如下图：</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898521489968.jpg"
            title="20210906-1630898521489968.jpg"
            alt="wps13.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >巧用光线构图：利用反光面和倒影，来创作独特的构图，如下图：</span
          >
        </p>
        <p style="text-align: center">
          <img
            src="../img/skill/20210906-1630898535603197.jpg"
            title="20210906-1630898535603197.jpg"
            alt="wps14.jpg"
          />
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >上述所言景别、运镜、构图都是我们拍摄短视频时，需要掌握并时时练习的基本技巧，而在基础技巧之外，还有一些非技巧类短视频拍摄要点，有助于帮助我们提升拍摄能力。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >3</span
            ></strong
          ><strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >.短视频拍摄其他技注意事项</span
            ></strong
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >1、细心观察，经常练习</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >常常观察身边可拍摄的人、物、景，如果手上没有相机，就用手机，随时拍摄，运用你掌握的各种拍摄技巧。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >练习预测对象的移动，及按下快门的时机。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >2、多拍摄黑白照片</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            ><span style="font-family: 微软雅黑"
              >拍摄黑白照片的目的在于，它能让我们专注于基本的元素</span
            ><span style="font-family: 微软雅黑"
              >U光线、故事、形式、情绪与讯息，更能捕捉真实与原始的美感。</span
            ></span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >3、学会观察几何图形的物体</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >通过观察几何图形物体，练习搭配直线、斜线、圆的、方的，加上阴影，锻炼构图能力。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >4、习惯等待</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >我们拍摄时往往急于看到一个东西就拍，我们要学会并习惯等待，等待画面中更精彩的瞬间，等待一个更有趣的故事，然后让他们呈现在你的视频中。</span
          >
        </p>
        <p>
          <strong
            ><span style="font-family: 微软雅黑; font-size: 14px"
              >5、同一个地方不同角度多次拍摄</span
            ></strong
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >不同的时间，去同一个地方，找不同的角度，根据光线强弱、方向、景物的变化等拍摄，你会感受到不一样的意境，不一样的心情，练习不同的拍摄技法。</span
          >
        </p>
        <p>
          <span style="font-family: 微软雅黑; font-size: 14px"
            >但是切记：台上三分钟，台下十年功</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import headerBar from './common/headerBar'

export default {
  name: "notice",
  components: {
    headerBar
  },
  data: function() {
    return {};
  },
  methods: {
    routerTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
  width: 100%;
  margin: 0 auto 0;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .back {
    font-size: 0.36rem;
    color: #0b0b0b;
    font-weight: bold;
    cursor: pointer;
    img {
      vertical-align: middle;
      width: 0.26rem;
      margin-top: -0.1rem;
      margin-left: 0.45rem;
    }
  }
  .content {
    width: calc(100% - 0.9rem);
    background-color: #fff;
    padding: 0 0.45rem 0.6rem;
    box-sizing: border-box;
    margin: 0 0.45rem;
    text-align: center;
    margin-top: 1rem;
    .title {
        position: relative;
        top: -0.45rem;
        width: 40%;
        height: 0.9rem;
        line-height: 0.88rem;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 0.44rem;
        text-align: center;
        font-size: 0.58rem;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -1.1rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/left.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -1.2rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/right.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    p {
      text-align: left;
      font-size: 28px;
      color: #0b2ab0;
      line-height: 1.4;
    }
    .p_left {
      text-indent: 0;
    }
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #0b2ab0;
      text-align: left;
      margin-top: 35px;
    }
    h3 {
      font-size: 28px;
      color: #0b2ab0;
      text-align: left;
      margin-top: 20px;
      text-indent: 1em;
    }
    .word {
      font-size: 16px;
      font-family: 'Microsoft Yahei' !important;
      color: #666;
      line-height: 38px;
      strong {
        font-weight: bold;
      }
      h1,h2,h3,h4,h5,h6 {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }
      img {
        max-width: 554px !important;
      }
      p {
        line-height: 1.2;
        margin-bottom: 5px;
        color: #0b2ab0;
        word-break: break-all;
        span {
          font-size: 14px;
          font-family: 'Microsoft Yahei';
        }
        a {
          color: #0b2ab0;
        }
        strong {
          font-weight: bold;
        }
        em {
          font-style: italic;
        }
        img {
          max-width: 100% !important;
          text-indent: 0;
          margin-bottom: 0px;
        }
        video {
          margin-left: -2em;
        }
        h1,h2,h3,h4,h5,h6 {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
